var exports = {
  "O": "titleLoadingSkeleton__hMQDz-",
  "r": "metadataLoadingSkeleton__fdIfiR",
};

module.exports = exports;
